import * as React from "react";
import { IPricing } from "src/services/interfaces/calculator/IPricing";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import { formatCurrency } from "src/util/Masks/formatCurrency";
export const PricingResultPrice = (props: { pricing: IPricing, showAllData: boolean }) => (
  <>
    <span className="subtitle">Preços</span>
    <div className="region-container">
      <div className="row">
        <span className="left description">Preço:</span>
        <span className="right description"><b>{formatCurrency(props.pricing?.price)}</b></span>
      </div>
      {props.showAllData &&
        <div className="row">
          <span className="left description">Preço Mínimo:</span>
          <span className="right description">{formatCurrency(props.pricing?.minPrice)}</span>
        </div>
      }
      {props.pricing?.maxPrice !== 0 && props.showAllData &&
        <div className="row">
          <span className="left description">Preço Máximo:</span>
          <span className="right description">{formatCurrency(props.pricing?.maxPrice)}</span>
        </div>
      }
      <div className="row">
        <span className="left description">Percentual de Oferta:</span>
        <span className="right description">{PercentageMask(props.pricing?.desagioValue, 2, 2)}</span>
      </div>
    </div>
  </>
)



// WEBPACK FOOTER //
// ./src/components/common/pricing-result/PricingResultPrice.tsx